module.exports = __webpack_public_path__ + "img/html.eadd5845.svg";